/* @ngInject */
function CampaignActionPostItemController ($scope, $rootScope, Utils, CONSTANTS) {
  const api = {

  }

  this.getApi = () => api

  $scope.getThumbnail = function (thumbnailId) {
    return Utils.fnReplaceStringParams(CONSTANTS.URL_CUSTOMER_ASSETS_THUMBNAIL_ID, [thumbnailId])
  }

  $scope.unselectPost = () => {
    $rootScope.$emit('campaign.attach-post-actions', null)
  }
}

export { CampaignActionPostItemController }
